export default __webpack_public_path__ + "locales/si/Payments.json?hash=c9c89c6dfd207837de15ddae875ec6de";